<template>
    <CheckboxGroup
        :value="value"
        @input="$emit('input', $event)"
        :options="priorities"
    />
</template>

<script>
    import { ISSUE_PRIORITY } from '@/constants';
    import CheckboxGroup from '@/components/CheckboxGroup.vue';

    export default {
        name: 'PrioritySelector',
        components: {
            CheckboxGroup,
        },
        props: {
            value: {
                type: Number,
                default: 0,
            },
        },
        computed: {
            priorities() {
                return [
                    {
                        key: ISSUE_PRIORITY.MEDIUM,
                        value: this.$t('Normal'),
                        status: 'bg-60',
                    },
                    {
                        key: ISSUE_PRIORITY.HIGH,
                        value: this.$t('High'),
                        status: 'bg-red',
                    },
                ];
            },
        },
    };
</script>
